import { styled } from '@mui/material';
import { TableCell } from '../table';
import { TABLE_HIERARCHY_INDENTS } from './constants';
export var TableHierarchyCell = styled(TableCell, {
    shouldForwardProp: function (prop) { return prop !== 'nestLevel'; },
})(function (_a) {
    var nestLevel = _a.nestLevel;
    return ({
        '&.MuiTableCell-root': {
            paddingLeft: TABLE_HIERARCHY_INDENTS[nestLevel],
        },
    });
});
